import React, {Component} from 'react';

class SupporterElement extends Component {
    render() {
        const { supporter, shift, location, route, supportersAvailable} = this.props;
        let supporterAvailable = supportersAvailable.indexOf(supporter.id) !== -1
        return (
            <div className={"SupporterElement widget bg-" + (supporter.checkedIn ? 'primary' : (supporterAvailable ? 'warning' : 'success'))}>
                <div>
                    <div className="checkbox checkbox-default pull-right">
                        <input type="checkbox" disabled={this.props.syncing} checked={supporter.checkedIn} id={"checkIn-" + supporter.id + '-' + shift.id + '-' + location.id + '-' + route.id} onChange={this.props.handleSupporterCheckIn}/>
                        <label htmlFor={"checkIn-" + supporter.id + '-' + shift.id + '-' + location.id + '-' + route.id}>Check-In</label>
                    </div>
                    <div className="checkbox checkbox-default pull-left">
                        <input type="checkbox" disabled={this.props.syncing} checked={supporterAvailable} id={"available-" + supporter.id + '-' + shift.id + '-' + location.id + '-' + route.id} onChange={this.props.handleSupporterAvailable}/>
                        <label htmlFor={"available-" + supporter.id + '-' + shift.id + '-' + location.id + '-' + route.id}>Anwesend</label>
                    </div>
                </div>
                <div className="name text-center" style={{clear: 'both'}}>
                    {supporter.name}
                </div>
            </div>
        )
    }
}
export default SupporterElement;